export default __webpack_public_path__ + "static/media/spiner.63973523.png";